import { ProductItemSchema } from "@/schemas/product/product-item";
import { SubscriptionAssignmentSchema } from "./subscription-assignment";
import { z } from "zod";

export const SubscriptionItemSchema = z.object({
  Id: z.string().uuid(),
  DateSold: z.string().optional(),
  ExtendedAmount: z.number().optional(),
  ListPrice: z.number().optional(),
  ManualDiscount: z.number().optional(),
  PaidAmount: z.number().optional(),
  SalesPrice: z.number().optional(),
  VolumeDiscount: z.number().optional(),
  Name: z.string().optional(),
  Quantity: z.number().optional(),
  QuantityInUse: z.number().optional(),
  StripeId: z.string().optional(),
  PaidStatusCode: z.number().optional(),
  Unit: z.string().optional(),
  CurrencyId: z.string().uuid().optional(),
  InvoiceId: z.string().uuid().optional(),
  SalesOrderId: z.string().uuid().optional(),
  AccountId: z.string().uuid().optional(),
  AccountName: z.string().optional(),
  ProductId: z.string().uuid().optional(),
  ProductName: z.string().optional(),
  ProductNumber: z.string().optional(),
  QuoteId: z.string().uuid().optional(),
  Modified: z.string().optional(),
  StatusCode: z.number().optional(),
  Product: ProductItemSchema.optional(),
  QuantityAvailable: z.number().optional(),
  Assignments: SubscriptionAssignmentSchema.array().optional(),
  ActiveAssignments: SubscriptionAssignmentSchema.array().optional(),
  QtyUsed: z.number().optional(),
});

export type SubscriptionItemType = z.infer<typeof SubscriptionItemSchema>;
